import { Cookies } from 'react-cookie'
import { authCookieName } from './setAuthCookie'

interface Props {
  options?: {
    path: string
  }
}

export const removeAuthCookie = ({ options = { path: '/' } }: Props) => {
  if (typeof window === 'undefined')
    throw new Error(
      'Cookies.js::This method can only be called in the Client/browser',
    )

  const cookieInstance = new Cookies()

  cookieInstance.remove(authCookieName, {
    ...options,
  })

  cookieInstance.remove(authCookieName, {
    ...options,
    domain: '.unicity.com',
  })

  cookieInstance.remove(authCookieName, {
    ...options,
    domain: 'shop2.unicity.com',
  })

  // Clear the hostname as well to be sure the cookie is removed
  cookieInstance.remove(authCookieName, {
    ...options,
    domain: window.location.hostname,
  })
}
